import { DEFAULT_FEE_ENABLED, DEFAULT_FEE_POLICY, DEFAULT_FEE_RULES } from '../configuration.constants';

/**
 * Setters owned by the Fee Structure tab. Persistent state lives on the
 * controller's internal `state`; every method below routes through
 * `this.setState(partial)` and then triggers a host re-render.
 */
class FeeStructureDelegate {
    setFee(fee) {
        const numericFee = typeof fee === 'string' ? parseFloat(fee) : fee || 0;
        this.setState({ fee: isNaN(numericFee) ? 0 : numericFee });
    }

    setFeePolicy(feePolicy) {
        this.setState({ fee_policy: feePolicy || DEFAULT_FEE_POLICY });
    }

    setFeePolicyField(field, value) {
        this.setState((prev) => ({
            fee_policy: { ...prev.fee_policy, [field]: value }
        }));
    }

    setFeeRules(feeRules) {
        this.setState({ fee_rules: feeRules || DEFAULT_FEE_RULES });
    }

    setFeeEnabled(feeEnabled) {
        this.setState({
            fee_enabled: {
                instantFee: feeEnabled?.instantFee ?? DEFAULT_FEE_ENABLED.instantFee,
                volumeTiers: feeEnabled?.volumeTiers ?? DEFAULT_FEE_ENABLED.volumeTiers,
                productTypes: feeEnabled?.productTypes ?? DEFAULT_FEE_ENABLED.productTypes,
                freeAdvances: feeEnabled?.freeAdvances ?? DEFAULT_FEE_ENABLED.freeAdvances
            }
        });
    }

    toggleFeeSection(sectionKey) {
        this.setState((prev) => ({
            fee_enabled: {
                ...prev.fee_enabled,
                [sectionKey]: !prev.fee_enabled?.[sectionKey]
            }
        }));
    }

    appendFeeRule(rulesKey, rule) {
        this.setState((prev) => ({
            fee_rules: {
                ...prev.fee_rules,
                [rulesKey]: [...(prev.fee_rules[rulesKey] || []), rule]
            }
        }));
    }

    removeFeeRule(rulesKey, ruleId) {
        this.setState((prev) => ({
            fee_rules: {
                ...prev.fee_rules,
                [rulesKey]: (prev.fee_rules[rulesKey] || []).filter((rule) => rule.id !== ruleId)
            }
        }));
    }

    updateFeeRule(rulesKey, ruleId, field, value) {
        this.setState((prev) => ({
            fee_rules: {
                ...prev.fee_rules,
                [rulesKey]: (prev.fee_rules[rulesKey] || []).map((rule) =>
                    rule.id === ruleId ? { ...rule, [field]: value } : rule
                )
            }
        }));
    }
}

export default FeeStructureDelegate;
